import BaseApi from './BaseApi';

class AssignDoctorApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/assgin-doctor';
  }
}

export default AssignDoctorApi;
